import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAccount } from "../context/AccountContext";

// Doc: docs/CAPACITY_CREDITS_DESIGN.md §6 — "used / granted," never "open
// positions / capacity" (no refund on close, so a low/exhausted balance
// means cumulative lots ever opened, not currently-open exposure).
export default function CreditBanner() {
  const { selectedAccount } = useAccount();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const isTracked = selectedAccount && selectedAccount !== "All Accounts";
  const storageKey = isTracked ? `credit_banner_dismissed_${selectedAccount}` : null;

  const fetchStatus = useCallback(async () => {
    if (!isTracked) { setStatus(null); return; }
    try {
      const res = await axios.get("/credits/status", { params: { username: selectedAccount } });
      setStatus(res.data);
    } catch {
      setStatus(null);
    }
  }, [isTracked, selectedAccount]);

  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  useEffect(() => {
    setDismissed(storageKey ? localStorage.getItem(storageKey) === "1" : false);
  }, [storageKey]);

  if (!status || status.status === "ok" || status.status === "not_tracked") return null;

  const exhausted = status.status === "exhausted";
  if (!exhausted && dismissed) return null;

  const dismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, "1");
    setDismissed(true);
  };

  const bg = exhausted ? "#dc3545" : "#fd7e14";

  return (
    <div data-testid="credit-banner" style={{
      position: "fixed",
      top: 60,
      right: 16,
      zIndex: 1200,
      maxWidth: 360,
      background: bg,
      color: "#fff",
      borderRadius: 10,
      boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
      padding: "10px 14px 10px 16px",
      display: "flex",
      alignItems: "flex-start",
      gap: 10,
      fontSize: 13,
      lineHeight: 1.45,
    }}>
      <span style={{ flex: 1 }}>
        <strong style={{ display: "block", marginBottom: 2 }}>
          {exhausted ? "Capacity Credits Exhausted" : "Capacity Credits Low"}
        </strong>
        {exhausted
          ? `${selectedAccount} has used all its granted capacity credits (${status.balance} remaining). New short-leg suggestions are blocked until more credits are granted.`
          : `${selectedAccount} has ${status.balance} capacity credits left (below the ${status.threshold} threshold). Contact your admin to purchase more.`}
      </span>
      {!exhausted && (
        <button
          onClick={dismiss}
          title="Dismiss"
          style={{
            background: "none", border: "none", color: "#fff", cursor: "pointer",
            fontSize: 16, lineHeight: 1, padding: "0 2px", opacity: 0.8,
            flexShrink: 0, marginTop: 1,
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
